import React from "react";
import Heading from "../../components/Header/Heading";
import SectionHeading from "../../components/SectionHeading/SectionHeading";
import Lightbox from "../../components/Lightbox/Lightbox";
import {
  ContainerWrapper,
  ProjectsGrid,
  ProjectCard,
  ProjectImage,
  ProjectOverlay,
  ProjectTitle,
  ProjectDescription,
  VideoCard,
  VideoContainer,
  StatsSection,
  StatsGrid,
  StatBox,
  IntroText,
  VideoThumbnail,
  PlayButton,
} from "./Projects.style";

export default function Projects() {
  const [lightboxOpen, setLightboxOpen] = React.useState(false);
  const [lightboxIndex, setLightboxIndex] = React.useState(0);
  const [lightboxItems, setLightboxItems] = React.useState([]);

  React.useEffect(() => {
    document.title = "Our Projects — TrixieGroup & Association";
  }, []);

  const stats = [
    { number: "500+", label: "Installations" },
    { number: "50+", label: "Commercial Projects" },
    { number: "450+", label: "Residential Projects" },
    { number: "25", label: "Years Warranty" },
  ];

  const projects = [
    {
      image: "/imgs/solar panle installation.jpeg",
      title: "Solar Panel Installation",
      description: "Complete solar panel setup for residential property",
      category: "Residential",
    },
    {
      image: "/imgs/inverter installation.jpeg",
      title: "Inverter Installation",
      description: "High-capacity inverter system installation",
      category: "Commercial",
    },
    {
      image: "/imgs/inverter installation 02.jpeg",
      title: "Inverter Setup",
      description: "Professional inverter configuration and installation",
      category: "Commercial",
    },
    {
      image: "/imgs/WhatsApp Image 2026-04-02 at 4.59.25 PM.jpeg",
      title: "Solar Installation",
      description: "Complete solar power system deployment",
      category: "Residential",
    },
    {
      image: "/imgs/WhatsApp Image 2026-04-02 at 4.59.26 PM.jpeg",
      title: "Panel Array Installation",
      description: "Multi-panel solar array configuration",
      category: "Commercial",
    },
    {
      image: "/imgs/WhatsApp Image 2026-04-02 at 4.59.26 PM (1).jpeg",
      title: "Roof Solar Setup",
      description: "Rooftop solar panel installation",
      category: "Residential",
    },
    {
      image: "/imgs/WhatsApp Image 2026-04-02 at 4.59.26 PM (2).jpeg",
      title: "Power System Install",
      description: "Integrated power solution installation",
      category: "Industrial",
    },
    {
      image: "/imgs/WhatsApp Image 2026-04-02 at 4.59.27 PM.jpeg",
      title: "Solar Project",
      description: "Large-scale solar implementation",
      category: "Commercial",
    },
    {
      image: "/imgs/WhatsApp Image 2026-04-02 at 4.59.28 PM.jpeg",
      title: "Energy Solution",
      description: "Complete energy independence setup",
      category: "Residential",
    },
    {
      image: "/imgs/WhatsApp Image 2026-04-02 at 4.59.28 PM (1).jpeg",
      title: "Inverter Project",
      description: "Advanced inverter system deployment",
      category: "Commercial",
    },
    {
      image: "/imgs/WhatsApp Image 2026-04-02 at 4.59.28 PM (2).jpeg",
      title: "Solar Deployment",
      description: "Professional solar system installation",
      category: "Industrial",
    },
    {
      image: "/imgs/WhatsApp Image 2026-04-02 at 4.59.28 PM (3).jpeg",
      title: "Power Installation",
      description: "Comprehensive power solution setup",
      category: "Residential",
    },
    {
      image: "/imgs/WhatsApp Image 2026-04-02 at 4.59.28 PM (4).jpeg",
      title: "Solar Array",
      description: "High-efficiency solar panel array",
      category: "Commercial",
    },
    {
      image: "/imgs/WhatsApp Image 2026-04-02 at 4.59.28 PM (5).jpeg",
      title: "Energy System",
      description: "Integrated solar energy solution",
      category: "Industrial",
    },
    {
      image: "/imgs/WhatsApp Image 2026-04-02 at 4.59.28 PM (6).jpeg",
      title: "Panel Installation",
      description: "Premium solar panel installation",
      category: "Residential",
    },
    {
      image: "/imgs/WhatsApp Image 2026-04-02 at 4.59.28 PM (7).jpeg",
      title: "Solar Setup",
      description: "Complete residential solar system",
      category: "Residential",
    },
    {
      image: "/imgs/WhatsApp Image 2026-04-02 at 4.59.29 PM.jpeg",
      title: "Inverter Solution",
      description: "Custom inverter configuration",
      category: "Commercial",
    },
  ];

  const videos = [
    {
      src: "/imgs/WhatsApp Video 2026-04-02 at 4.59.35 PM.mp4",
      title: "Installation Process",
      description: "Time-lapse of complete solar installation",
      thumbnail: "/imgs/solar panle installation.jpeg",
    },
    {
      src: "/imgs/WhatsApp Video 2026-04-02 at 4.59.35 PM (1).mp4",
      title: "System Setup",
      description: "Behind-the-scenes of inverter installation",
      thumbnail: "/imgs/inverter installation.jpeg",
    },
    {
      src: "/imgs/WhatsApp Video 2026-04-02 at 5.00.27 PM.mp4",
      title: "Project Showcase",
      description: "Completed installation walkthrough",
      thumbnail: "/imgs/inverter installation 02.jpeg",
    },
  ];

  const openImageLightbox = (index) => {
    const items = projects.map(p => ({ src: p.image, title: p.title, description: p.description }));
    setLightboxItems(items);
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  const openVideoLightbox = (index) => {
    const items = videos.map(v => ({ src: v.src, title: v.title, description: v.description, type: "video" }));
    setLightboxItems(items);
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  return (
    <ContainerWrapper>
      <SectionHeading data-aos="fade-up">OUR PROJECTS</SectionHeading>

      <Heading data-aos="fade-up" data-aos-delay="100">
        Showcasing Our{" "}
        <span className="highlight">Solar &amp; Inverter</span> Installations
      </Heading>

      <IntroText data-aos="fade-up" data-aos-delay="200">
        Browse through our portfolio of completed solar and inverter installations.
        From residential rooftops to commercial complexes, we deliver reliable
        renewable energy solutions tailored to each client's needs.
      </IntroText>

      <StatsSection data-aos="fade-up" data-aos-delay="300">
        <StatsGrid>
          {stats.map((stat, index) => (
            <StatBox key={index}>
              <div className="stat-number">{stat.number}</div>
              <div className="stat-label">{stat.label}</div>
            </StatBox>
          ))}
        </StatsGrid>
      </StatsSection>

      <SectionHeading data-aos="fade-up" data-aos-delay="400">
        PHOTO GALLERY
      </SectionHeading>

      <ProjectsGrid data-aos="fade-up" data-aos-delay="500">
        {projects.map((project, index) => (
          <ProjectCard
            key={index}
            data-aos="fade-up"
            data-aos-delay={index * 50}
            onClick={() => openImageLightbox(index)}
          >
            <ProjectImage src={project.image} alt={project.title} loading="lazy" />
            <ProjectOverlay>
              <span className="category">{project.category}</span>
              <ProjectTitle>{project.title}</ProjectTitle>
              <ProjectDescription>{project.description}</ProjectDescription>
              <span className="view-hint">Click to view</span>
            </ProjectOverlay>
          </ProjectCard>
        ))}
      </ProjectsGrid>

      <SectionHeading data-aos="fade-up">VIDEO SHOWCASE</SectionHeading>

      <ProjectsGrid data-aos="fade-up">
        {videos.map((video, index) => (
          <VideoCard key={index} data-aos="fade-up" data-aos-delay={index * 100}>
            <VideoContainer onClick={() => openVideoLightbox(index)}>
              <VideoThumbnail src={video.thumbnail} alt={video.title} />
              <PlayButton>
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z"/>
                </svg>
              </PlayButton>
            </VideoContainer>
            <div className="video-info">
              <ProjectTitle>{video.title}</ProjectTitle>
              <ProjectDescription>{video.description}</ProjectDescription>
            </div>
          </VideoCard>
        ))}
      </ProjectsGrid>

      <Lightbox
        isOpen={lightboxOpen}
        onClose={closeLightbox}
        items={lightboxItems}
        currentIndex={lightboxIndex}
        onNavigate={setLightboxIndex}
      />
    </ContainerWrapper>
  );
}
